import { render, staticRenderFns } from "./JoinRoom.vue?vue&type=template&id=60f87d13&scoped=true&"
import script from "./JoinRoom.vue?vue&type=script&lang=js&"
export * from "./JoinRoom.vue?vue&type=script&lang=js&"
import style0 from "./JoinRoom.vue?vue&type=style&index=0&id=60f87d13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f87d13",
  null
  
)

export default component.exports